import { pluralize } from "../pluralize/index.js";

export const getItemName = ({
  itemType,
  quantity,
  volume,
  unit,
  extended,
}: {
  itemType: "draught" | "bottle" | "can" | "bagInBox" | string | null;
  quantity: number;
  volume?: number | null;
  unit?: "gal" | "L" | "ml" | "cl" | "pt" | "oz" | "g" | "kg" | null;
  extended: boolean;
}): string => {
  if (!itemType) {
    return pluralize("item", quantity);
  }

  if (itemType === "draught") {
    return pluralize("draught item", quantity);
  }

  if (itemType === "bottle" || itemType === "can") {
    if (extended) {
      return `${pluralize("case", quantity)} of ${itemType}s`;
    }
    return pluralize("case", quantity);
  }

  if (itemType === "bagInBox") {
    return `bag in ${pluralize("box", quantity)}`;
  }

  return `${pluralize(itemType, quantity)}${volume && unit ? ` over ${volume}${unit}` : ""}`;
};
